import client from "./client";

export const fetchContact = async () =>{
    const response = await client.get("contact_info")
    return response.data;
};